const Roles = {
    SUPER_USER: "SuperUser",
    TRANSLATOR: "Translator"
}

export default Roles;